// hooks/useNotificationClick.js
import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";

export const useNotificationClick = (onNotification) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const handled = useRef(false);

  
  // App already open
  useEffect(() => {
    const handler = (event) => {
      if (event.data?.source === "NOTIFICATION_CLICK") {
        onNotification(event.data.notificationType, event.data);
      }
    };
    navigator.serviceWorker?.addEventListener("message", handler);
    return () =>
      navigator.serviceWorker?.removeEventListener("message", handler);
  }, [onNotification]);

  // App opened from notification — runs on mount AND whenever searchParams changes,
  // so it catches the case where the URL is updated after the initial render
  // (e.g. PWA cold-start where the app loads from cache before navigating to the notification URL).
  useEffect(() => {
    if (handled.current) return;
    const type = searchParams.get("notif_type");
    if (type) {
      handled.current = true;
      onNotification(type, {
        title: searchParams.get("notif_title") || "",
        body: searchParams.get("notif_body") || "",
        id: searchParams.get("notif_id") || null,
        image: searchParams.get("notif_image") || null,
      });
      const newParams = new URLSearchParams(searchParams);
      newParams.delete("notif_type");
      newParams.delete("notif_title");
      newParams.delete("notif_body");
      newParams.delete("notif_id");
      newParams.delete("notif_image");
      setSearchParams(newParams, { replace: true });
    }
  }, [searchParams, onNotification, setSearchParams]);
};


